// extracted by mini-css-extract-plugin
export var badge = "_g5-2";
export var detailsPanel = "_g5-0";
export var resultRow = "_g5-1";